import {
  Grid,
  TableCell,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableContainer,
  Paper,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  DialogContent,
  DialogContentText,
  Link
} from '@material-ui/core';
import React, { Component } from 'react';
import PageHeader from '../common/PageHeader';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import _ from 'lodash';
import Reports from './Reports';
import './report.less';
import moment from 'moment';
import { DateFormat, DateFormatMMDDYYYY } from '../../constants/appConstants';
import ReportButtons from './ReportButtons';
import {
  EnhancedTableHead,
  GenerateAbsoluteURL,
  getLast3PayPeriodData,
  IsSensitiveDataAccess,
  orderBy,
  removeDuplicates
} from '../../utils/helper';
import { getFormattedValues, getFormattedValuesForReport } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { param } from 'jquery';
import { collapsableReimbursement, extendibleMarketArray } from '../../constants/MockData';
import { getMultilevelGroupedData } from '../../utils/generic';
import AdvancedFilter from './AdvancedFilter';

let defaultPayPeriod = [];
const rowrender = { count: 0 };

export default class PropertyVarianceDetails extends Component {
  constructor (props) {
    super(props);
    this.state = {
      showMain: false,
      marketMasterData: [],
      propertyReimburseData: [],
      empSummaryRows: [],
      showReport: false,
      openSlidingPanel: false,
      printPage: false,
      lastPayPeriod: [],
      order: 'asc',
      orderBy: 'nam',
      isPopupOpen: false,
      employeeSummary: [],
      confirmationMessage: '',
      msgTitle: '',
      row: [],
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Client',
              value: 'client',
              id: 'client',
              ssrsReport: 'Client',
              numeric: false,
              disablePadding: false,
              label: 'Client',
              type: 'Text'
            },
            {
              key: 'Legal Entity',
              id: 'legalEntity',
              value: 'legalEntity',
              ssrsReport: 'LegalEntity',
              numeric: false,
              disablePadding: false,
              label: 'Legal Entity',
              type: 'Text'
            },
            {
              key: 'Service Type',
              value: 'serviceType',
              id: 'serviceType',
              ssrsReport: 'ServiceType',
              numeric: false,
              disablePadding: false,
              label: 'Service Type',
              type: 'Text'
            },
            {
              key: 'Property Name',
              value: 'propertyName',
              id: 'propertyName',
              ssrsReport: 'PropertyName',
              numeric: false,
              disablePadding: false,
              label: 'Property',
              type: 'Text'
            },
            {
              key: 'Property Type',
              value: 'propertyType',
              id: 'propertyType',
              ssrsReport: 'PropertyType',
              numeric: false,
              disablePadding: false,
              label: 'Property Type',
              type: 'Text'
            },
            {
              key: 'Account Code Name',
              value: 'accountCode',
              id: 'accountCode',
              ssrsReport: 'AccountCode',
              numeric: false,
              disablePadding: false,
              label: 'Account Code Name',
              type: 'Text'
            },
            {
              key: 'Employee',
              value: 'employeeName',
              id: 'employeeName',
              ssrsReport: 'Employee',
              numeric: false,
              disablePadding: false,
              label: 'Employee',
              type: 'Text'
            },
            {
              key: 'Expense Group',
              value: 'expenseGroup',
              id: 'expenseGroup',
              ssrsReport: 'ExpenseGroup',
              numeric: false,
              disablePadding: false,
              label: 'Expense Group',
              type: 'Text'
            },
            {
              key: 'Expense Name',
              value: 'expenseName',
              id: 'expenseName',
              ssrsReport: 'ExpenseName',
              numeric: false,
              disablePadding: false,
              label: 'Expense Name',
              type: 'Text'
            }],
          selected: [{
            key: 'Market',
            value: 'marketName',
            id: 'marketName',
            ssrsReport: 'Market',
            numeric: false,
            disablePadding: false,
            label: 'Market',
            type: 'Text'
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: false,
        summaryRows: false,
        suppressDetails: false,
        showZeroNGraph: true,
        showLink: false
      }

    };
    this.baseState = this.state;
  }

  componentDidMount () {
    this.GetPropertyReimburseData();
  }

    goBack = () => {
      this.setState({
        showMain: true
      });
    };

    handleClose = () => {
      this.setState({
        openSlidingPanel: false
      });
    };

    handlePrintClick = () => {
      this.handleExport('application/pdf', 'Pdf', true);
    };

    GetPropertyReimburseData = (ssrsCall = 5) => {
      const date = getLast3PayPeriodData();
      const params = {
        payPeriodStartDate: moment(date[0]).format(DateFormat),
        payPeriodEndDate: moment(date[1]).format(DateFormat),
        ssrsCall: ssrsCall
      };
      this._asyncRequest = apiBatchRequest([
        {
          url: API_URL.Report.GetPropertyReimburseData,
          params,
          key: 'propertyReimburseData'
        }
      ])
        .then(({ propertyReimburseData }) => {
          this._asyncRequest = null;
          if (propertyReimburseData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          const empSummaryRows = this.getTableRow(propertyReimburseData.data, propertyReimburseData.config,
            propertyReimburseData.rawData.find(x => x === true) !== undefined);
          this.setState({
            propertyReimburseData: propertyReimburseData.data,
            empSummaryRows,
            showReport: true,
            lastPayPeriod: propertyReimburseData.config,
            showLink: propertyReimburseData.rawData.find(x => x === true) !== undefined
          });
        })
        .catch(() => {
          this._asyncRequest = null;
        });
    };

    renderTableCell = (groupedData, payPeriod, showLink) => {
      const tableCell = [];
      let evenOddClass = '';
      let reimbursementCostPayPeriod2 = 0; let reimbursementCostPayPeriod3 = 0; let variancePercent = 0;

      groupedData.forEach((d, i) => {
        evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
        tableCell.push(
            <TableRow key={i} className={evenOddClass}>
                <TableCell className={
                    evenOddClass + 'st sticky'
                }>
                    {getFormattedValues(d.marketName, 'Text')}{' '}
                </TableCell>
                { payPeriod.map((pay, payIndex) => {
                  return (<TableCell key = {i + payIndex} className={
                        evenOddClass + 'st sticky-' + (payIndex + 1)
                    }>
                        {getFormattedValues(d['reimbursementCost_' + pay.payPeriod], 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
                    </TableCell>);
                })
                }
                <TableCell className={
                    evenOddClass + 'st sticky-4'
                }>
                    {getFormattedValues(d.currentVariance, 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
                </TableCell>
                <TableCell className={
                    evenOddClass + 'st sticky-5'
                }>
                    {getFormattedValues(d.variancePercent, 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
                </TableCell>
                { payPeriod.map((pay, payIndex) => {
                  return (<TableCell key = {i + payIndex} className={
                        evenOddClass
                    }>
                        {getFormattedValues(d['flatRate_' + pay.payPeriod], 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
                    </TableCell>);
                })
                }
                <TableCell className={
                    evenOddClass
                }>
                    {getFormattedValues(d.currentFlatRateVariance, 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
                </TableCell>
                { payPeriod.map((pay, payIndex) => {
                  return (<TableCell key = {i + payIndex} className={
                        evenOddClass
                    }>
                        {getFormattedValues(d['propertyBillingPercent_' + pay.payPeriod], 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
                    </TableCell>);
                })
                }
                <TableCell className={
                    evenOddClass
                }>
                    {getFormattedValues(d.currentPropertyBillingPercentVariance, 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
                </TableCell>
                { payPeriod.map((pay, payIndex) => {
                  return (<TableCell key = {i + payIndex} className={
                        evenOddClass
                    }>
                        { (IsSensitiveDataAccess() && showLink === true && d['billableCount_' + pay.payPeriod] > 0)
                          ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of Billable Allocations', 'Employee', 'billableCount'); }} style = {{ cursor: 'pointer' }}>
                             {getFormattedValues(d['billableCount_' + pay.payPeriod], 'Number')}
                            </Link>
                          : getFormattedValues(d['billableCount_' + pay.payPeriod], 'Number')}{' '}
                    </TableCell>);
                })
                }
                { payPeriod.map((pay, payIndex) => {
                  return (<TableCell key = {i + payIndex} className={
                        evenOddClass
                    }>
                        { (IsSensitiveDataAccess() && showLink === true && d['newEmployee_' + pay.payPeriod] > 0)
                          ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of New Allocations', 'Employee', 'newEmployee'); }} style = {{ cursor: 'pointer' }}>
                             {getFormattedValues(d['newEmployee_' + pay.payPeriod], 'Number')}
                            </Link>
                          : getFormattedValues(d['newEmployee_' + pay.payPeriod], 'Number')}{' '}

                    </TableCell>);
                })
                }
                { payPeriod.map((pay, payIndex) => {
                  return (<TableCell key = {i + payIndex} className={
                        evenOddClass
                    }>
                         { (IsSensitiveDataAccess() && showLink === true && d['terminatedEmployees_' + pay.payPeriod] > 0)
                           ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of Terminated Allocations', 'Property', 'terminatedEmployees'); }} style = {{ cursor: 'pointer' }}>
                             {getFormattedValues(d['terminatedEmployees_' + pay.payPeriod], 'Number')}
                            </Link>
                           : getFormattedValues(d['terminatedEmployees_' + pay.payPeriod], 'Number')}{' '}

                    </TableCell>);
                })
                }
                { payPeriod.map((pay, payIndex) => {
                  return (<TableCell key = {i + payIndex} className={
                        evenOddClass
                    }>
                        { (IsSensitiveDataAccess() && showLink === true && d['newProperty_' + pay.payPeriod] > 0)
                          ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of New Billable Properties', 'Property', 'newProperty'); }} style = {{ cursor: 'pointer' }}>
                             {getFormattedValues(d['newProperty_' + pay.payPeriod], 'Number')}
                            </Link>
                          : getFormattedValues(d['newProperty_' + pay.payPeriod], 'Number')}{' '}

                    </TableCell>);
                })
                }
                { payPeriod.map((pay, payIndex) => {
                  return (<TableCell key = {i + payIndex} className={
                        evenOddClass
                    }>
                        { (IsSensitiveDataAccess() && showLink === true && d['employeeWithNoBurdenRate_' + pay.payPeriod] > 0)
                          ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of Employees with No Burden Rate', 'Employee', 'employeeWithNoBurdenRate'); }} style = {{ cursor: 'pointer' }}>
                             {getFormattedValues(d['employeeWithNoBurdenRate_' + pay.payPeriod], 'Number')}
                            </Link>
                          : getFormattedValues(d['employeeWithNoBurdenRate_' + pay.payPeriod], 'Number')}{' '}

                    </TableCell>);
                })
                }
            </TableRow>
        );
      });
      evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      tableCell.push(
        <TableRow className={evenOddClass}>
            <TableCell className={
                evenOddClass + 'st sticky'
            }>
               <b> {getFormattedValues('Total', 'Text')}{' '}</b>
            </TableCell>
            { payPeriod.map((pay, payIndex) => {
              if (payIndex === 1) {
                reimbursementCostPayPeriod2 = groupedData.reduce((total, obj) => (parseFloat(obj['reimbursementCost_' + pay.payPeriod]) + parseFloat(total)), 0);
              } else if (payIndex === 2 && reimbursementCostPayPeriod2 > 0) {
                reimbursementCostPayPeriod3 = groupedData.reduce((total, obj) => (parseFloat(obj['reimbursementCost_' + pay.payPeriod]) + parseFloat(total)), 0);
                variancePercent = ((reimbursementCostPayPeriod3 - reimbursementCostPayPeriod2) / (reimbursementCostPayPeriod2 === 0 ? null : reimbursementCostPayPeriod2)) * 100;
              }
              return (<TableCell key = {payIndex} className={
                    evenOddClass + 'st sticky-' + (payIndex + 1)
                }>
                    <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['reimbursementCost_' + pay.payPeriod]) + parseFloat(total)), 0), 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>
                </TableCell>);
            })
            }
            <TableCell className={
                evenOddClass + 'st sticky-4'
            }>
                <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj.currentVariance) + parseFloat(total)), 0), 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>
            </TableCell>
            <TableCell className={
                evenOddClass + 'st sticky-5'
            }>
                {/* <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj.variancePercent) + parseFloat(total)), 0), 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b> */}
                <b>{getFormattedValues(variancePercent, 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>

            </TableCell>
            { payPeriod.map((pay, payIndex) => {
              return (<TableCell key = {payIndex} className={
                    evenOddClass
                }>
                    <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['flatRate_' + pay.payPeriod]) + parseFloat(total)), 0), 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>

                </TableCell>);
            })
            }
            <TableCell className={
                evenOddClass
            }>
                <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj.currentFlatRateVariance) + parseFloat(total)), 0), 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>
            </TableCell>
            { payPeriod.map((pay, payIndex) => {
              return (<TableCell key = {payIndex} className={
                    evenOddClass
                }>
                    <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['propertyBillingPercent_' + pay.payPeriod]) + parseFloat(total)), 0), 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>
                </TableCell>);
            })
            }
            <TableCell className={
                evenOddClass
            }>
                <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj.currentPropertyBillingPercentVariance) + parseFloat(total)), 0), 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>

            </TableCell>
            { payPeriod.map((pay, payIndex) => {
              return (<TableCell key = {payIndex} className={
                    evenOddClass
                }>
                    <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['billableCount_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>

                </TableCell>);
            })
            }
            { payPeriod.map((pay, payIndex) => {
              return (<TableCell key = {payIndex} className={
                    evenOddClass
                }>
                    <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['newEmployee_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>
                </TableCell>);
            })
            }
            { payPeriod.map((pay, payIndex) => {
              return (<TableCell key = {payIndex} className={
                    evenOddClass
                }>
                    <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['terminatedEmployees_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>
                </TableCell>);
            })
            }
            { payPeriod.map((pay, payIndex) => {
              return (<TableCell key = {payIndex} className={
                    evenOddClass
                }>
                    <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['newProperty_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>
                </TableCell>);
            })
            }
            { payPeriod.map((pay, payIndex) => {
              return (<TableCell key = {payIndex} className={
                    evenOddClass
                }>
                    <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['employeeWithNoBurdenRate_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>
                </TableCell>);
            })
            }
        </TableRow>
      );
      return tableCell;
    };

    getTableRow = (propertyReimburseData, payPeriod, showLink) => {
      let returnRows = [];

      returnRows = [...returnRows, ...this.renderTableCell(
        orderBy(propertyReimburseData, this.state.orderBy, this.state.order),
        payPeriod,
        showLink
      )];
      return returnRows;
    }

    renderTable = (empSummaryRows) => {
      const { lastPayPeriod } = this.state;

      return (
        <Table className="reportTable" id="rptTable" key="rptTable">
          <TableHead>
          <TableRow className='background-table-header'>
            <TableCell colSpan={1} className='right-border'>
            </TableCell>
            <TableCell colSpan={13} align='center' className='right-border'>
              Reimbursement Details
            </TableCell>
            <TableCell align='center' colSpan={15}>
                 Reason for Variance
            </TableCell>
          </TableRow>
          <TableRow className='background-table-header'>
            <TableCell className='st sticky right-border'>
            </TableCell>
            <TableCell align='center' className='st sticky-1 right-border' colSpan={5}>
                Reimbursement Cost
            </TableCell>
            <TableCell align='center' className = 'right-border' colSpan={4}>
                Total Flat Rate ($)
            </TableCell>
            <TableCell align='center' className = 'right-border' colSpan={4}>
                Total Billing Percent
            </TableCell>
            <TableCell align='center' className = 'right-border' colSpan={3}>
                Count of Billable Allocations
            </TableCell>
            <TableCell align='center' className = 'right-border' colSpan={3}>
                Count of New Allocations
            </TableCell>
            <TableCell align='center' className = 'right-border' colSpan={3}>
                Count of Terminated Allocations
            </TableCell>
            <TableCell align='center' className = 'right-border' colSpan={3}>
                Count of New Billable Properties
            </TableCell>
            <TableCell align='center' className = 'right-border' colSpan={3}>
                Count of Employees with No Burden Rate
            </TableCell>
          </TableRow>
          <TableRow className='background-table-header'>
            <TableCell className='st sticky right-border'>Market Name</TableCell>
            {lastPayPeriod.map((x, i) => {
              return (
                    <TableCell className={'st sticky-' + (i + 1)} key = {i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            <TableCell className='st sticky-4'>Current Variance ($)</TableCell>
            <TableCell className='st sticky-5 right-border'>Current Variance (%)</TableCell>
            {lastPayPeriod.map((x, i) => {
              return (
                    <TableCell key = {i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            <TableCell className = 'right-border'>Current Variance ($)</TableCell>
            {lastPayPeriod.map((x, i) => {
              return (
                    <TableCell key = {i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            <TableCell className = 'right-border'>Current Variance (%)</TableCell>
            {lastPayPeriod.map((x, i) => {
              return (
                    <TableCell className = {i === 2 ? 'right-border' : ''} key = {i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
             {lastPayPeriod.map((x, i) => {
               return (
                    <TableCell className = {i === 2 ? 'right-border' : ''} key = {i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
               );
             })}
             {lastPayPeriod.map((x, i) => {
               return (
                    <TableCell className = {i === 2 ? 'right-border' : ''} key = {i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
               );
             })}
             {lastPayPeriod.map((x, i) => {
               return (
                    <TableCell className = {i === 2 ? 'right-border' : ''} key = {i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
               );
             })}
             {lastPayPeriod.map((x, i) => {
               return (
                    <TableCell className = {i === 2 ? 'right-border' : ''} key = {i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
               );
             })}
          </TableRow>
          </TableHead>
          <TableBody>{empSummaryRows}</TableBody>
        </Table>
      );
    };

    handleExport = (fileMimeType, type, isPrint) => {
      this.downloadFile(fileMimeType, type, isPrint);
    }

    downloadFile = (fileMimeType, type, isPrint) => {
      const date = getLast3PayPeriodData();
      const dataValue = [
        { key: 'StartDate', value: moment(date[0]).format(DateFormat) },
        { key: 'EndDate', value: moment(date[1]).format(DateFormat) }
      ];
      const url = GenerateAbsoluteURL(dataValue, [], 'Property%20Variance%20Detail%20Report', type);
      downloadReport(
        url,
        'Property Variance Details Report',
        fileMimeType,
        type,
        isPrint
      );
    }

    resetPage = () => {
      const { advanceFilterConfig } = this.state;
      advanceFilterConfig.summaryRows = false;
      advanceFilterConfig.suppressZero = false;
      advanceFilterConfig.suppressDetails = false;
      advanceFilterConfig.groupBy = {
        masterData: [
          {
            key: 'Client',
            value: 'client',
            id: 'client',
            ssrsReport: 'Client',
            numeric: false,
            disablePadding: false,
            label: 'Client',
            type: 'Text'
          },
          {
            key: 'Legal Entity',
            id: 'legalEntity',
            value: 'legalEntity',
            ssrsReport: 'LegalEntity',
            numeric: false,
            disablePadding: false,
            label: 'Legal Entity',
            type: 'Text'
          },
          {
            key: 'Service Type',
            value: 'serviceType',
            id: 'serviceType',
            ssrsReport: 'ServiceType',
            numeric: false,
            disablePadding: false,
            label: 'Service Type',
            type: 'Text'
          },
          {
            key: 'Property Name',
            value: 'propertyName',
            id: 'propertyName',
            ssrsReport: 'PropertyName',
            numeric: false,
            disablePadding: false,
            label: 'Property',
            type: 'Text'
          },
          {
            key: 'Property Type',
            value: 'propertyType',
            id: 'propertyType',
            ssrsReport: 'PropertyType',
            numeric: false,
            disablePadding: false,
            label: 'Property Type',
            type: 'Text'
          },
          {
            key: 'Account Code Name',
            value: 'accountCode',
            id: 'accountCode',
            ssrsReport: 'AccountCode',
            numeric: false,
            disablePadding: false,
            label: 'Account Code Name',
            type: 'Text'
          },
          {
            key: 'Employee',
            value: 'employeeName',
            id: 'employeeName',
            ssrsReport: 'Employee',
            numeric: false,
            disablePadding: false,
            label: 'Employee',
            type: 'Text'
          },
          {
            key: 'Expense Group',
            value: 'expenseGroup',
            id: 'expenseGroup',
            ssrsReport: 'ExpenseGroup',
            numeric: false,
            disablePadding: false,
            label: 'Expense Group',
            type: 'Text'
          },
          {
            key: 'Expense Name',
            value: 'expenseName',
            id: 'expenseName',
            ssrsReport: 'ExpenseName',
            numeric: false,
            disablePadding: false,
            label: 'Expense Name',
            type: 'Text'
          }],
        selected: [{
          key: 'Market',
          value: 'marketName',
          id: 'marketName',
          ssrsReport: 'Market',
          numeric: false,
          disablePadding: false,
          label: 'Market',
          type: 'Text'
        }]

      };
      this.setState({
        advanceFilterConfig
      });
    };

    GetSummaryDetails = (data, payPeriodStartDate, payPeriodEndDate, msg, type) => {
      const params = {
        payPeriodStartDate: moment(payPeriodStartDate).format(DateFormat),
        payPeriodEndDate: moment(payPeriodEndDate).format(DateFormat),
        ssrsCall: 6,
        marketId: data.marketId?.toString(),
        varianceType: type
      };
      this._asyncRequest = apiBatchRequest([
        {
          url: API_URL.Report.GetPropertyReimburseData,
          params,
          key: 'propertyReimburseData'
        }
      ])
        .then(({ propertyReimburseData }) => {
          this._asyncRequest = null;
          if (propertyReimburseData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          const payPeriod = [{
            payPeriod: params.payPeriodEndDate,
            isCollapsed: true
          }];
          defaultPayPeriod = payPeriod;
          propertyReimburseData.data = propertyReimburseData.data.filter(x => x.marketName === data.marketName);

          const rows = this.getPropertyTableRow(propertyReimburseData.data);

          this.setState({
            rows,
            payPeriod,
            employeeSummary: propertyReimburseData.data,
            isPopupOpen: true,
            confirmationMessage: data.marketName + ' details for Pay period ' + moment(params.payPeriodStartDate).format(DateFormatMMDDYYYY) + '-' + moment(params.payPeriodEndDate).format(DateFormatMMDDYYYY),
            msgTitle: msg
          });
        })
        .catch(() => {
          this._asyncRequest = null;
        });
    }

    onPopupClickHandle = (value, data, payPeriodStartDate, payPeriodEndDate, msg, selected, type) => {
      if (value) {
        const advanceFilterConfig = this.state.advanceFilterConfig;
        const selectedMenu = advanceFilterConfig.groupBy.masterData.find(x => x.label === selected);
        if (selectedMenu !== undefined) {
          advanceFilterConfig.groupBy.masterData = ((advanceFilterConfig.groupBy || {})
            .masterData || []).filter(x => x.value !== selectedMenu.value);
          advanceFilterConfig.groupBy.selected = ((advanceFilterConfig.groupBy || {})
            .selected || []).filter(x => x.value !== selectedMenu.value);
          advanceFilterConfig.groupBy.selected.push(selectedMenu);
        }
        this.setState({
          advanceFilterConfig
        }, () => {
          this.GetSummaryDetails(data, payPeriodStartDate, payPeriodEndDate, msg, type);
        });
      } else {
        this.setState({ isPopupOpen: false, employeeSummary: [], confirmationMessage: '', row: [], expand: false, payPeriod: [], msgTitle: '' }, () => {
          this.resetPage();
        });
      }
    }

    getSupprssDetailsColumnCount = () => {
      if (this.state.advanceFilterConfig.suppressDetails) {
        const columns = [];
        const allColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
        const selectedColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
        const diffColumns = allColumns.length - selectedColumns.length;
        for (let c = 0; c < diffColumns; c++) {
          columns.push(c + 1);
        }
        return columns;
      } else {
        return [];
      }
    }

  renderPropertyReimbursementTable = (rows) => {
    const { payPeriod } = this.state;
    const groupSequence = this.getColumnSequence();
    const suppressColumns = this.getSupprssDetailsColumnCount();
    const collapsableObj = collapsableReimbursement;
    const extendibleArray = extendibleMarketArray;

    return (
      <Table className="reportTable" id="rptTable" key="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={rows.length} // {propertyReimburseData.length}
          columnSequence={groupSequence}
          headCells={[]}
          payPeriod={payPeriod}
          isSensitiveData={true}
          dynamicColumnCount={[1, 2, 3, 4, 5, 6, 7, 8, 9]}
          suppressDetailsColumnCount={suppressColumns}
          extendibleArray={extendibleArray}
          collapsableObj={collapsableObj}
          onClickOnArrow={this.onClickOnArrow}
          expand={this.state.expand}
          expandAll={this.expandAll}
          suppressDetails = {this.state.advanceFilterConfig.suppressDetails}
        />

        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
    } else {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
    }
  }

  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
      currentGroupedRow.push({ key: x.value });
    }
    );
    return currentGroupedRow;
  }

  getGroupedArray (d, key) {
    return '';
  }

  renderPropertyReimbursementTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const suppressDetails = this.state.advanceFilterConfig.suppressDetails;
    const sequence = this.getColumnSequence();
    let column1 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[0]?.value) || {}).value ?? '' : '';
    let column2 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[1]?.value) || {}).value ?? '' : '';
    let column3 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[2]?.value) || {}).value ?? '' : '';
    let column4 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[3]?.value) || {}).value ?? '' : '';
    let column5 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[4]?.value) || {}).value ?? '' : '';
    let column6 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[5]?.value) || {}).value ?? '' : '';
    let column7 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[6]?.value) || {}).value ?? '' : '';
    let column8 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[7]?.value) || {}).value ?? '' : '';
    let column9 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[8]?.value) || {}).value ?? '' : '';
    let column10 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[9]?.value) || {}).value ?? '' : '';
    // const { payPeriod } = this.state;
    const payPeriod = defaultPayPeriod;
    const isSelected = false;
    groupedData.forEach((d, i) => {
      if (d.data !== undefined) {
        // rowCount = 0;
        currentGroupedRow = currentGroupedRow.filter(x => x.key !== d.key);
        currentGroupedRow.push({ key: d.key, value: d[d.key] });
        if (this.state.advanceFilterConfig.summaryRows === false) {
          this.renderPropertyReimbursementTableCell(d.data, currentGroupedRow, tableCell, rowCount);
        }
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(currentGroupedRow));
      const selectedKey = this.state.advanceFilterConfig.groupBy.selected.map(x => x.key);
      if (d.reimbursmentDetails) {
        const evenOddClass =
          tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
        const topBorderClass =
          column1 !== (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
        const key = rowCount + '_' + i;
        if (d.reimbursmentDetails.length > 0 && (d.reimbursmentDetails[0].isSummary === undefined ||
          (d.reimbursmentDetails.length > 0 && d.reimbursmentDetails[0].isSummary === true &&
            this.state.advanceFilterConfig.summaryRows === true))) {
          if ((suppressDetails && d.isGroup) || (!suppressDetails)) {
            tableCell.push(
              <TableRow
                // key={key}
                className={(this.state.advanceFilterConfig.summaryRows === true ? topBorderClass : '') + (d.isGroup === true ? ' parent-row' : '')}
              >{(!suppressDetails || (suppressDetails && sequence[0]?.value !== '')) && (
                <TableCell
                  className={'st sticky ' + evenOddClass + (column1 !== d[sequence[0]?.value] &&
                    ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[0]?.value])
                    ? topBorderClass
                    : '')}
                >
                  {getFormattedValues(column1 !== d[sequence[0]?.value] && d[sequence[0]?.value], 'Text')// ===
                    // '-'
                    // ? [...new Set(d.data.map(x => x[sequence[0].value]))].length
                    // : getFormattedValues(column1 !== d[sequence[0].value] && d[sequence[0].value], 'Text')
                  }{' '}
                  {/* {d.isGroup === true ? [...new Set(d.data.map(x => x[sequence[0].value]))].length : ''} */}
                </TableCell>
              )
                }
                {(!suppressDetails || (suppressDetails && sequence[1]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-1 ' +
                      evenOddClass +
                      (column2 !== d[sequence[1]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[1]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {(column2 !== d[sequence[1].value]) === false && d.isGroup === true ? this.getGroupedArray(d, sequence[1].value) : getFormattedValues(column2 !== d[sequence[1].value] && d[sequence[1].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[1].value) : getFormattedValues(column2 !== d[sequence[1].value] && d[sequence[1].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[1]?.value)}</span>
                      : (getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text') === null ? <span className='total-count'>-</span> : getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text'))}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[2]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-2 ' +
                      evenOddClass +
                      (column3 !== d[sequence[2]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[2]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {getFormattedValues(column3 !== d[sequence[2].value] && d[sequence[2].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[2].value) : getFormattedValues(column3 !== d[sequence[2].value] && d[sequence[2].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[2]?.value)}</span>
                      : getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[3]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-3 ' +
                      evenOddClass +
                      (column4 !== d[sequence[3]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[3]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {getFormattedValues(column4 !== d[sequence[3].value] && d[sequence[3].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[3].value) : getFormattedValues(column4 !== d[sequence[3].value] && d[sequence[3].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[3]?.value)}</span>
                      : getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[4]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-4 ' +
                      evenOddClass +
                      (column5 !== d[sequence[4]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[4]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {getFormattedValues(column5 !== d[sequence[4].value] && d[sequence[4].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[4].value) : getFormattedValues(column5 !== d[sequence[4].value] && d[sequence[4].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[4]?.value)}</span>
                      : getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[5]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-5 ' +
                      evenOddClass +
                      (column6 !== d[sequence[5]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[5]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {getFormattedValues(column6 !== d[sequence[5].value] && d[sequence[5].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[5].value) : getFormattedValues(column6 !== d[sequence[5].value] && d[sequence[5].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[5]?.value)}</span>
                      : getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[6]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-6 ' +
                      evenOddClass +
                      (column7 !== d[sequence[6]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[6]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {getFormattedValues(column7 !== d[sequence[6].value] && d[sequence[6].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[6].value) : getFormattedValues(column7 !== d[sequence[6].value] && d[sequence[6].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column7 !== d[sequence[6]?.value] && d[sequence[6]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[6]?.value)}</span>
                      : getFormattedValues(column7 !== d[sequence[6]?.value] && d[sequence[6]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[7]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-7 ' +
                      evenOddClass +
                      (column8 !== d[sequence[7]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[7]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {getFormattedValues(column7 !== d[sequence[6].value] && d[sequence[6].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[6].value) : getFormattedValues(column7 !== d[sequence[6].value] && d[sequence[6].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column8 !== d[sequence[7]?.value] && d[sequence[7]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[7]?.value)}</span>
                      : getFormattedValues(column8 !== d[sequence[7]?.value] && d[sequence[7]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[8]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-8 ' +
                      evenOddClass +
                      (column9 !== d[sequence[8]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[8]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {getFormattedValues(column7 !== d[sequence[6].value] && d[sequence[6].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[6].value) : getFormattedValues(column7 !== d[sequence[6].value] && d[sequence[6].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column9 !== d[sequence[8]?.value] && d[sequence[8]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[8]?.value)}</span>
                      : getFormattedValues(column9 !== d[sequence[8]?.value] && d[sequence[8]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[9]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-9 ' +
                      evenOddClass +
                      (column10 !== d[sequence[9]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[9]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {/* {getFormattedValues(column7 !== d[sequence[6].value] && d[sequence[6].value], 'Text')}{' '} */}
                    {/* {d.isGroup === true ? this.getGroupedArray(d, sequence[6].value) : getFormattedValues(column7 !== d[sequence[6].value] && d[sequence[6].value], 'Text')} */}
                    {d.isGroup === true && getFormattedValues(column10 !== d[sequence[9]?.value] && d[sequence[9]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[9]?.value)}</span>
                      : getFormattedValues(column10 !== d[sequence[9]?.value] && d[sequence[9]?.value], 'Text')}
                  </TableCell>
                )
                }
                {payPeriod?.map((date, ind) => (
                  this.renderReimbursementColumn(d.reimbursmentDetails, date, key + ind, evenOddClass, d)
                ))}
              </TableRow>
            );
          }
        }
        rowCount++;
        rowrender.count++;
        column1 = (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '';
        column2 = (keyvalue.find(x => x.key === sequence[1]?.value) || {}).value ?? '';
        column3 = (keyvalue.find(x => x.key === sequence[2]?.value) || {}).value ?? '';
        column4 = (keyvalue.find(x => x.key === sequence[3]?.value) || {}).value ?? '';
        column5 = (keyvalue.find(x => x.key === sequence[4]?.value) || {}).value ?? '';
        column6 = (keyvalue.find(x => x.key === sequence[5]?.value) || {}).value ?? '';
        column7 = (keyvalue.find(x => x.key === sequence[6]?.value) || {}).value ?? '';
        column8 = (keyvalue.find(x => x.key === sequence[7]?.value) || {}).value ?? '';
        column9 = (keyvalue.find(x => x.key === sequence[8]?.value) || {}).value ?? '';
        column10 = (keyvalue.find(x => x.key === sequence[9]?.value) || {}).value ?? '';
      }
      if (d.data !== undefined && this.state.advanceFilterConfig.summaryRows === true && d.isGroup === true) {
        this.renderPropertyReimbursementTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      }
    });
    return tableCell;
  };

  expandAll = (e) => {
    const collapsePayPeriod = (this.state.payPeriod || []);

    (collapsePayPeriod.filter(d => d.isCollapsed === e.target.checked) || []).forEach((x) => {
      x.isCollapsed = !e.target.checked;
    });
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getPropertyTableRow(this.state.employeeSummary || []);
    this.setState({
      expand: e.target.checked,
      payPeriod: collapsePayPeriod,
      rows
    });
  }

  renderReimbursementColumn = (reimbursementDetails, payPeriod, index, evenOddClass, d) => {
    const reimbursementDetail = reimbursementDetails;
    const tableCell = [];
    const collapsableObj = collapsableReimbursement;
    const extendibleArray = extendibleMarketArray;
    tableCell.push(<>
      {payPeriod.isCollapsed === false && (
        <>
          {
            extendibleArray.map((obj, i) => (
              <TableCell className={(evenOddClass + 'rpt-topBorder')} key={obj.key + i}>
                {
                  reimbursementDetail.map((reimburse, ind) =>
                    <div
                      key={index + obj.key + i + ind} className={((reimbursementDetail.length) > 1 && ind !== (reimbursementDetail.length - 1))
                        ? 'multi-pay-period'
                        : ''}>
                      {d.isGroup === true && obj.format === 'DecimalPercent' && reimburse[obj.key] === undefined
                        ? <span className='total-count'>{this.getGroupedArray(reimburse, reimburse[obj.key])}</span>
                        : reimburse[obj.key] === null
                          ? <span className="number-text">-</span>
                          : getFormattedValuesForReport(reimburse[obj.key], obj.format, obj.appendText)}
                    </div>

                  )
                }
              </TableCell>
            ))
          }
        </>)
      }
      <TableCell className={(evenOddClass + 'right-border  rpt-topBorder')} key={index + collapsableObj.key}>
        {
          reimbursementDetail.map((reimburse, ind) =>
            <div
              key={index + collapsableObj.key + ind} className={((reimbursementDetail.length) > 1 && ind !== (reimbursementDetail.length - 1))
                ? 'multi-pay-period'
                : ''}>
              { d.isGroup === true && collapsableObj.format === 'DecimalPercent' && reimburse[collapsableObj.key] === undefined
                ? <span className='total-count'>{this.getGroupedArray(reimburse, reimburse[collapsableObj.key])}</span>
                : reimburse[collapsableObj.key] === null
                  ? <span className="number-text">-</span>
                  : getFormattedValuesForReport(reimburse[collapsableObj.key], collapsableObj.format, collapsableObj.appendText)}</div>
          )
        }
      </TableCell>
    </>);
    return tableCell;
  }

  renderPropertyTableRow = (data) => {
    if (this.state.advanceFilterConfig.suppressZero === true) {
      data = data.filter(x => {
        return _.chain(x.reimbursmentDetails).sumBy(x => x.reimbursementCost).value() !== 0;
      });
    }
    if (this?.state?.advanceFilterConfig?.showSummary !== true) {
      data = _.chain(data).orderBy(this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), 'asc').value();
    }
    return this.renderPropertyReimbursementTableCell(
      getMultilevelGroupedData(data, this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), true),
      []);
  };

  getPropertyTableRow = (propertyReimburseData) => {
    let returnRows = [];
    returnRows = [...returnRows, ...this.renderPropertyTableRow(
      orderBy(propertyReimburseData, this.state.orderBy, this.state.order)
    )];
    return returnRows;
  }

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    let rows = [];
    rows = [...rows, ...this.getPropertyTableRow(
      orderBy((this.state.employeeSummary || []), property, isAsc ? 'desc' : 'asc')
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      rows
    }, () => { this.forceUpdate(); });
  };

  onClickOnArrow = (payPeriod, isCollapsed) => {
    const collapsePayPeriod = (this.state.payPeriod || []);
    collapsePayPeriod.find(d => d.payPeriod === payPeriod).isCollapsed = !isCollapsed;
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getPropertyTableRow(this.state.employeeSummary || []);
    this.setState({
      payPeriod: collapsePayPeriod,
      handleCollapse: !this.state.handleCollapse,
      rows
    }, () => { this.forceUpdate(); });
  }

  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  onAddvanceFilterChange = (advanceFilterConfig) => {
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false

    }, () => {
      const rows = this.getPropertyTableRow(this.state.employeeSummary || []);
      this.setState({
        rows
      });
    });
  }

  handleSubmit = () => {
    const rows = this.getPropertyTableRow(this.state.employeeSummary || []);

    this.setState({
      rows
    });
  };

  handleClickOpen = () => {
    this.setState({
      openSlidingPanel: true
    });
  };

  render () {
    const {
      showMain,
      marketMasterData,
      propertyReimburseData,
      empSummaryRows,
      showReport,
      isPopupOpen,
      confirmationMessage,
      msgTitle,
      rows,
      expand,
      handleCollapse,
      advanceFilterConfig,
      openSlidingPanel,
      employeeSummary
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    return (
        <>
            {isPopupOpen && (
            <Dialog open={isPopupOpen} maxWidth="xl" fullWidth={true} >
            <AppBar
                style={{ position: 'relative', backgroundColor: '#064473' }}
            >
                <Toolbar>
                <Typography
                    variant="h6"
                    className="app-header-white"
                    style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                    {confirmationMessage}
                </Typography>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="close"
                    style = {{ paddingLeft: '40px' }}
                >
                    <IoMdCloseCircleOutline onClick={() => { this.onPopupClickHandle(false); }}
                />
                </IconButton>
                </Toolbar>
            </AppBar>
                <DialogContent dividers>
                <DialogContentText style = {{ color: '#002f6c' }}>
                  <label> <b> {msgTitle} </b> </label>
                </DialogContentText>
                <Grid container className="no-print row top-xs end-xs" style={{ marginTop: '-40px' }}>
                    <ReportButtons
                    handleSubmit={this.handleSubmit}
                    handleClickOpen={this.handleClickOpen}
                    data={employeeSummary}
                    hideAdvanceFilter = {true}
                    hideButtons = {true}
                    />
                </Grid>
                <div className="col-lg-3 buttons">
                <div className="col-lg-12">
                  <AdvancedFilter
                    payPeriodStartDate={this.state.payPeriodStartDate}
                    payPeriodEndDate={this.state.payPeriodEndDate}
                    filterConfig={advanceFilterConfig}
                    onApplyFilter={this.onAddvanceFilterChange}
                    openSlidingPanel={openSlidingPanel}
                    handleClose={this.handleClose}
                  />
                </div>
              </div>
                <DialogContentText>
                <TableWithPaginations
                    tableData={rows} // {propertyReimburseData}
                    renderTable={this.renderPropertyReimbursementTable}
                    expand={expand}
                    order={this.state.order}
                    oBy={this.state.orderBy}
                    handleCollapse={handleCollapse}
                  />
                </DialogContentText>
                </DialogContent>

            </Dialog>
            )}
          {showMain
            ? (
              <Reports />
              )
            : (
              <>
                <PageHeader
                  key={'Property_Variance_Detail_Report'}
                  title={'Property Variance Detail Report'}
                  style={{ marginLeft: '1rem' }}
                  actionsConfig={[
                    {
                      icon: (
                        <ArrowBackIcon
                          size="small"
                          className="back-button no-print"
                        />
                      ),
                      onClick: this.goBack,
                      title: 'Back to Report'
                    }
                  ]}
                >
                  Property Variance Detail Report
              </PageHeader>
                <Grid container className="no-print row top-xs end-xs">
                  <ReportButtons
                    handlePrintClick={this.handlePrintClick}
                    downloadFile={this.handleExport}
                    data={propertyReimburseData}
                    hideAdvanceFilter = {true}
                    hideAdvanceLink = {true}
                    hideButtons = {false}
                  />
                </Grid>
                {showReport &&
                  propertyReimburseData !== null &&
                  propertyReimburseData.length > 0 && (
                    <TableContainer
                        component={Paper}
                        style={{ maxWidth: '100vw' }}
                    >
                        {this.renderTable(empSummaryRows)}
                    </TableContainer>
                )}
                {showReport &&
                  (propertyReimburseData == null ||
                    propertyReimburseData.length <= 0) && (
                    <Grid container spacing={4}>
                      <Grid
                        container
                        direction="row-reverse"
                        justify="center"
                        alignItems="stretch"
                      >
                        <label className="item-big">No Data Available.</label>
                      </Grid>
                    </Grid>
                )}
              </>
              )}
        </>
    );
  }
}
